export interface PrintReportFailure {
  message: string
}
export interface PrintReportServerData {
  Data: {
    FileName: string
    ServerID: number
  }
}

export enum PrintReportServiceErrorCode {
  GENERAL,
}

export enum ReportTypes {
  LOAN = 'loan',
  LOANCOLLATERAL = 'loanCollateral',
  CLIENT = 'client',
  APPLICATION = 'application',
  COLLATERAL = 'collateral',
  ACCOUNT = 'account',
  ENTRY = 'entry',
  ENTRYCONVERT = 'entryConvert',
  LOANCALCULATOR = 'loancalculator',
  COLLATERALMNG = 'collateralmng',
  REPORTING = 'reporting',
  SDACRA = 'sdacra',
}

export type PrintReportPages =
  | 'printloandetail'
  | 'printloanorder'
  | 'printloanturnover'
  | 'printmemorder'
  | 'printcashin'
  | 'printcashout'
  | 'printconvacc'
  | 'printconvcash'
  | 'printaccstatement'
  | 'printcashinucc'
  | 'printloandemoschedule'
  | 'printsession'
  | 'printudr'
  | 'printframegroup'

type Hash =
  | { [ReportTypes.APPLICATION]: 'HashSum_PrintReportIDAppID_' }
  | { [ReportTypes.LOAN]: 'HashSum_PrintReportIDLoanID_' }
  | { [ReportTypes.LOANCOLLATERAL]: 'HashSum_PrintReportIDLoanIDCollateralID_' }
  | { [ReportTypes.CLIENT]: 'HashSum_PrintReportIDClientID_' }
  | { [ReportTypes.ENTRY]: 'HashSum_PrintReportIDEntryID_' }
  | { [ReportTypes.ENTRYCONVERT]: 'HashSum_PrintReportIDOID_' }
  | { [ReportTypes.LOANCALCULATOR]: 'HashSum_PrintReportIDDemoScheduleSequenceID_' }
  | { [ReportTypes.COLLATERALMNG]: 'HashSum_PrintReportIDCMSessionID_' }
  | { [ReportTypes.ACCOUNT]: 'HashSum_PrintReportIDAccountID_' }
  | { [ReportTypes.REPORTING]: 'HashSum_PrintReportIDReportID_' }
  | { [ReportTypes.SDACRA]: 'HashSum_PrintReportID_' }
  | { [ReportTypes.COLLATERAL]: 'HashSum_PrintReportIDCollateralID_' }
  | {}

export type PrintReportParams = {
  page: PrintReportPages
  PrintReportID?: number | string
  OperTypeID?: number
  printOption: number | string
  isCheckLoan?: boolean
  Format?: string
} & Hash &
  (
    | {
        AppID: number | string
        HashSum_AppID_: string
      }
    | {
        LoanID: number | string
        HashSum_LoanID_: string
      }
    | {
        DemoScheduleSequenceID: number | string
        HashSum_DemoScheduleSequenceID_: string
      }
    | {
        LoanID: number | string
        HashSum_LoanID: string
        CollateralID: number | string
        HashSum_CollateralID_: string
      }
    | {
        ClientID: number | string
        HashSum_ClientID_: string
      }
    | {
        CollateralID: number | string
        HashSum_CollateralID_: string
      }
    | {
        AccountID: number | string
        HashSum_AccountID_: string
      }
    | {
        EntryID: number | string
        HashSum_EntryID_: string
      }
    | {
        OID: number | string
        HashSum_OID_: string
      }
    | {
        CMSessionID: number | string
        HashSum_CMSessionID_: string
      }
    | {
        ReportID: number | string
        HashSum_ReportID_: string
      }
    | {}
  )
